export default __webpack_public_path__ + "static/media/topIcon.9556a02d.svg";